import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

interface LineAuthState {
  lineAccessToken: string | null;
  setLineAccessToken: (token: string | null) => void;
}

export const useLineAuth = create<LineAuthState>()(
  persist(
    (set) => ({
      lineAccessToken: null,
      setLineAccessToken: (token) => set({ lineAccessToken: token }),
    }),
    {
      name: "line-auth-storage",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
